const CheckboxView = ({ label, value = false, checkPosition = "left" }) => {
  return (
    <div className="my-4 flex items-start gap-2">
      {checkPosition === "left" && (
        <input type="checkbox" checked={value} className="check-style" />
      )}
      <label className="text-lightGreyText font-fw_400 text-fs_16 capitalize mt-[2px]">
        {label}
      </label>
      {checkPosition === "right" && (
        <input type="checkbox" checked={value} className="check-style" />
      )}
    </div>
  );
};

export default CheckboxView;
